//api
import aplicacionesLaborales from "../api/aplicacionesLaborales"

//ALTA APLICACIONLABORAL
export const CREATE_APLICACIONLABORAL = 'CREATE_APLICACIONLABORAL';
export const REQUEST_CREATE_APLICACIONLABORAL = "REQUEST_CREATE_APLICACIONLABORAL";
export const SUCCESS_CREATE_APLICACIONLABORAL = "SUCCESS_CREATE_APLICACIONLABORAL";
export const ERROR_CREATE_APLICACIONLABORAL = "ERROR_CREATE_APLICACIONLABORAL";
export const RESET_CREATE_APLICACIONLABORAL = "RESET_CREATE_APLICACIONLABORAL";


//ALTA APLICACIONLABORAL
function requestCreateAplicacionLaboral() {
    return {
        type: REQUEST_CREATE_APLICACIONLABORAL,
    }
}

export function errorCreateAplicacionLaboral(error) {
    return {
        type: ERROR_CREATE_APLICACIONLABORAL,
        error: error,
    }
}

function receiveCreateAplicacionLaboral(json) {
    return {
        type: SUCCESS_CREATE_APLICACIONLABORAL,
        receivedAt: Date.now(),
    }
}

export function resetCreateAplicacionLaboral() {
    return {
        type: RESET_CREATE_APLICACIONLABORAL
    }
}

export function createAplicacionLaboral(aplicacionLaboral) {
    return {
        type: CREATE_APLICACIONLABORAL,
        aplicacionLaboral
    }
}

export function saveCreateAplicacionLaboral(files) {
    return (dispatch, getState) => {
        dispatch(requestCreateAplicacionLaboral());
        return aplicacionesLaborales.saveCreate(getState().aplicacionesLaborales.create.nuevo, files)
            .then(function (response) {
                if (response.status >= 400) {
                    return Promise.reject(response);
                } else {
                    dispatch(receiveCreateAplicacionLaboral(response));
                    dispatch(resetCreateAplicacionLaboral());
                }
            })
            .catch(function (error) {
                console.log(error, error.status);
                switch (error.status) {
                    case 401:
                        dispatch(errorCreateAplicacionLaboral("Error de sesión"));
                        return;
                    default:
                        if (error.responseJSON.message != "")
                            dispatch(errorCreateAplicacionLaboral(JSON.parse(error.responseJSON.message)));
                        else
                            dispatch(errorCreateAplicacionLaboral('Ha ocurrido un error inesperado. Si el error continua contáctese con el administrador del sistema.'));

                        return;
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/actions/AplicacionLaboralActions.js